var CryptoJS = require("crypto-js");

function encryptByDES(message, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

function encryptByAES(message, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

function decryptByDES(ciphertext, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var decrypted = CryptoJS.DES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

function decryptByAES(ciphertext, key) {
    var keyHex = CryptoJS.enc.Utf8.parse(key);
    var decrypted = CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
    }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

function passwordGenerator(length) {
    var charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }

    return retVal;
}

export default class CryptoFunction {
    static generateKey = (keyLength = 128, mainKeyLength = 16, bits = 1024) => {
        let key = "";
        for(let i = 0; i < mainKeyLength; i++) {
            let retVal = passwordGenerator(keyLength);
            var hash = CryptoJS.MD5(CryptoJS.MD5(retVal).toString(CryptoJS.enc.Hex), { outputLength: bits });
            key += hash.toString(CryptoJS.enc.Hex);
        }

        return key;
    }

    static encryptDesAes = (val, key) => {
        return encryptByDES(encryptByAES(val, key), key)
        // return CryptoJS.DES.encrypt(CryptoJS.AES.encrypt(val, key), key);
        // return CryptoJS.TripleDES.encrypt(val, key).ciphertext.toString(CryptoJS.enc.Base64);
    }

    static decryptDesAes = (val, key) => {
        return decryptByAES(decryptByDES(val, key), key)
        // return CryptoJS.AES.decrypt(CryptoJS.DES.decrypt(val, key), key);
        // return CryptoJS.TripleDES.decrypt(val, key);
    }

    static megaHardPizdecEncrypt = (val, key) => {
        let cryptoText = val;
        for (let i = 0; i < 6; i++) {
            cryptoText = CryptoFunction.encryptDesAes(cryptoText, key);
        }

        return CryptoFunction.encryptDesAes(cryptoText, key);
    }

    static megaHardPizdecDecrypt = (val, key) => {
        let text = CryptoFunction.decryptDesAes(val, key);
        for (let i = 0; i < 6; i++) {
            text = CryptoFunction.decryptDesAes(text, key);
        }

        return text;
        // return CryptoFunction.encryptDesAes(cryptoText, key);
    }

    static onlyDESEncrypt = (val, key) => {
        return encryptByDES(val, key);
    }

    static onlyDESDecrypt = (val, key) => {
        return decryptByDES(val, key);
    }

    static onlyAESEncrypt = (val, key) => {
        return encryptByAES(val, key);
    }

    static onlyAESDecrypt = (val, key) => {
        return decryptByAES(val, key);
    }

    static MD5Hash = (val)=>{
        return CryptoJS.MD5(val).toString(CryptoJS.enc.Hex);
    }
}